import React, {useEffect, useState, useRef} from 'react';

import './NewslettersList.css';
import Table from '../Table';
import Pagination from "../Pagination";
import API from "../../utils/ApiParams"
import {Redirect} from "react-router-dom";
import Preview from "../modals/Preview";
import MailHtmlGenerator from "../../utils/MailHtmlGenerator";
import ReactDOMServer from "react-dom/server";
import Loading from "../Loading";

function NewslettersList() {
    function copyNewsletter(id) {
        setToNewsletterEdition({navigate:true, id: id, action:"duplicate"});
    }
    function modifyNewsletter(id) {
        setToNewsletterEdition({navigate:true, id: id, action:"edit"});
    }
    function readNewsletter(id) {
        setToNewsletterEdition({navigate:true, id: id, action:"read"});
    }
    function previewNewsletter(id) {
        async function getNewsletter() {
            const response = await API.get("newsletters/"+id);
            return response.data;
        }
        getNewsletter().then(data=>{
            setCoverUrl(`${process.env.REACT_APP_API_URL}images/${data.coverImage.id}/${data.coverImage.name}`);
            setArticles(data.articles.map(art=>({
                id: art.id,
                title: art.title,
                categories: [...new Map(art.categories.map(item => [item.id, item])).values()].sort((a,b)=>{return a.position - b.position}),
                coverUrl: `${process.env.REACT_APP_API_URL}images/${art.thumbnail ? art.thumbnail.id : art.coverImage.id}/${art.thumbnail ? art.thumbnail.name : art.coverImage.name}`,
                text: art.shortText,
                author: art.author.name
            })));
            setIsFlash(data.isFlash);
            setShowPreview(true);
        })
    }
    const [toNewsletterEdition,setToNewsletterEdition] = useState({navigate: false,id: null});

    const [shownNewsletterNumber,setShownNewsletterNumber] = useState(5);
    const [searched,setSearched] = useState("");
    const [page, setPage] = useState(1);
    const [newsletters, setNewsletters] = useState([]);
    const [totalNewsletters, setTotalNewsletters] = useState(0);
    const [newslettersLoaded, setNewslettersLoaded] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [articles, setArticles] = useState([]);
    const [coverUrl,setCoverUrl] = useState(null);
    const [isFlash,setIsFlash] = useState(false);

    const searchDebounceRef = useRef(null);

    // Reset to page 1 when the search or page size changes
    useEffect(() => {
        setPage(1);
    }, [searched, shownNewsletterNumber]);

    useEffect(()=>{
        if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);

        const delay = searched ? 300 : 0;
        searchDebounceRef.current = setTimeout(() => {
        async function getNewsletters() {
            const params = new URLSearchParams({
                'order[id]': 'desc',
                page: page,
                itemsPerPage: shownNewsletterNumber,
            });
            if (searched) params.append('search', searched);

            const response = await API.get(`newsletters?${params}`, {
                headers: { accept: 'application/ld+json' }
            });
            const members = response.data['hydra:member'] ?? response.data;
            const total = response.data['hydra:totalItems'] ?? members.length;
            setTotalNewsletters(total);
            return members.map(newsletter=>(
                {
                    title : {
                        format: "img",
                        url :  process.env.REACT_APP_API_URL+"images/"+newsletter.coverImage.id+"/"+newsletter.coverImage.name,
                        className : "tableImg",
                        value : newsletter.object?newsletter.object:newsletter.pushTitle?newsletter.pushTitle:""
                    },
                    format : {format: "txt",value : newsletter.format},
                    sendingDate : {format: "date",
                        value : newsletter.sendingDate ? new Date(newsletter.sendingDate) : new Date(newsletter.pushSendingDate)},
                    sent : {format:"txt", value: newsletter.sentMail ? `${newsletter.deliveredMail}/${newsletter.sentMail}` : " "},
                    action : {format: "button", id : newsletter.id, value : [
                            canModify(newsletter) && {handleClick: modifyNewsletter, text: "Modifier", className : "actionButton modifyButton"},
                            {handleClick: copyNewsletter, text: "Dupliquer", className : "actionButton duplicateButton"},
                            newsletter.format.toUpperCase() !== "PUSH" && {handleClick: previewNewsletter, text: "Prévisualiser", className : "actionButton previewButton"},
                        ]},
                    status : {format: "status",value : newsletter.status.index},
                    newsletter: {format: "txt", value: newsletter.id},
                    defaultAction: {handleClick:canModify(newsletter)?modifyNewsletter:readNewsletter, id:newsletter.id},
                }
            ))
        }
        getNewsletters().then(data=>{
            // Ordering is handled server-side (order[id]=desc)
            setNewsletters(data)
            setNewslettersLoaded(true);
        });
        }, delay);
    }, [page, shownNewsletterNumber, searched])
    function canModify(newsletter) {
        let modify = false;
        if(new Date(newsletter.sendingDate) > new Date( Date.now() - 1000 * (60 * 5) ))
            modify = true;
        if (new Date(newsletter.pushSendingDate) > new Date( Date.now() - 1000 * (60 * 5) ))
            modify = true;
        if(!newsletter.idEmailCampaign && newsletter.sendingDate)
            modify = true;
        if(!newsletter.idOneSignal && newsletter.pushSendingDate)
            modify = true;
        return modify;
    }
    function handleChangeNbNewsletter(event){
        if(event.target.value>0){
            setShownNewsletterNumber(event.target.value);
        }
    }
    function handleChangeSearch(event){
        setSearched(event.target.value);
    }
    function handleChangePage(newPage){
        setPage(newPage);
    }

    if (toNewsletterEdition.navigate){
        return (
            <Redirect push to={{
                pathname:"/newsletters/creation",
                state: {id : toNewsletterEdition.id, action : toNewsletterEdition.action}
            }}/>
        )
    }
    const firstOnPage = totalNewsletters === 0 ? 0 : (page - 1) * shownNewsletterNumber + 1;
    const lastOnPage = Math.min(page * shownNewsletterNumber, totalNewsletters);

    return (
        newslettersLoaded ?
        <div className={"newslettersList"}>
            <main className={"main"}>
                    <div className={"filterBar"}>
                        <div className={"filterNumber"}>
                            <input className={"inputNumber"} type="number" value={shownNewsletterNumber} onChange={handleChangeNbNewsletter}/>
                            <span> enregistrements par page</span>
                        </div>
                        <input className={`customInput ${searched!==""?"activeFilter":""}`} placeholder={"Rechercher"} type="text" value={searched} onChange={handleChangeSearch}/>
                    </div>
                    <Table headers={{
                        title: "Titre",
                        format : "Format",
                        sendingDate : "Date d'envoi",
                        sent : "Envoi",
                        action : "Action",
                        status: "Statut",
                        newsletter: "Newsletter"
                    }}
                           elements={newsletters}
                           currentPage={1}
                           elementsPerPage={newsletters.length}/>
                </main>
            <div className={"flex space-between pagination"}>
               <span>
                   {firstOnPage}-{lastOnPage} enregistrements sur un total de {totalNewsletters} enregistrements
               </span>
                <Pagination currentPage={page} pageElement={shownNewsletterNumber}
                            totalElements={totalNewsletters} pageNeighbours={2}
                            handleChangePage={handleChangePage}/>
            </div>
            {(showPreview && articles.length > 0) &&
                <Preview component={
                    <iframe title={"Mail Preview"} srcDoc={ReactDOMServer.renderToStaticMarkup(MailHtmlGenerator(articles,coverUrl,isFlash))}
                            className={"previewContent"}></iframe>
                } boxWrapperClass={"previewMail"} isOpen={showPreview} handleClose={()=> setShowPreview(false)} iframe={true}/>
            }
        </div>
        : <Loading/>
    );
}

export default NewslettersList;
